"use client";

import { sponsor } from "@/features/sponsor";
import { Toaster } from "@dafiti/closet-ui";
import { useEnvContext } from "next-runtime-env";
import { useEffect, useRef } from "react";

import * as track from "../../tracking/catalogPage.tracking";
import type { CatalogMetaResponse } from "../../types/catalog.type";
import {
  clearSearchAction,
  getSearchAction,
  mapSearchActionToType,
} from "../../types/searchTracking.helper";

type InitProps = {
  meta: CatalogMetaResponse;
  searchQuantityResult: number;
  searchTerm: string;
};

export const Init = ({ meta, searchQuantityResult, searchTerm }: InitProps) => {
  const catalogSegment = meta.tracking_context?.catalog_segment?.join("-");
  const searchEventEmitted = useRef(false);
  const { NEXT_PUBLIC_COUNTRY, NEXT_PUBLIC_GFG_ADS_HOST } = useEnvContext();

  useEffect(() => {
    track.storeCountry(NEXT_PUBLIC_COUNTRY?.toLowerCase() as string);
    track.deviceUUID();
    sponsor.setupAdsTracking({ host: NEXT_PUBLIC_GFG_ADS_HOST! });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    track.pageView({ meta });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogSegment]);

  useEffect(() => {
    if (searchEventEmitted.current) return;
    const searchAction = getSearchAction();

    if (!searchAction) {
      return;
    }

    const term = searchTerm.replace(/^\/(s|c|b)\//, "").replace(/-/g, " ");

    const searchType = mapSearchActionToType(searchAction);
    track.searchEvent({
      searchTerm: term,
      resultsQuantity: searchQuantityResult,
      searchType,
    });

    clearSearchAction();
    searchEventEmitted.current = true;
  }, [searchQuantityResult]);

  return <Toaster />;
};
